import { createMixpanelEvent } from '../../../../../shared/utils/events/mixpanel/events/base';
import { CollectionPageEventTypes } from '../types';

const { pageView, header, itemTabs, sellerCard, inspire } = CollectionPageEventTypes;

export const CollectionPageMixpanelEvents = {
    [pageView]: createMixpanelEvent(),

    [header.menu.clicked]: createMixpanelEvent('Collection Page - Header Menu - clicked'),
    [header.actions.shareWithTeam.clicked]: createMixpanelEvent('Collection Page - Header Action - clicked'),
    [header.actions.socialShare.clicked]: createMixpanelEvent('Collection Page - Header Action - clicked'),
    [header.actions.copyCollection.clicked]: createMixpanelEvent('Collection Page - Header Action - clicked'),
    [header.actions.edit.clicked]: createMixpanelEvent('Collection Page - Header Action - clicked'),
    [header.actions.delete.clicked]: createMixpanelEvent('Collection Page - Header Action - clicked'),

    [itemTabs.tab.clicked]: createMixpanelEvent('Collection Page - item tab clicked'),

    [sellerCard.clicked]: createMixpanelEvent('Collection Page - Seller Card - clicked'),
    [sellerCard.contact.clicked]: createMixpanelEvent('Collection Page - Seller Card - contact clicked'),
    [sellerCard.availableServices.clicked]: createMixpanelEvent(
        'Collection Page - Seller Card - available services clicked'
    ),

    [inspire.banner.click]: createMixpanelEvent('GoToApp Banner - Click'),

    [header.actions.copyCollection.success]: createMixpanelEvent('Collection copied'),
    [header.actions.copyCollection.fail]: createMixpanelEvent('Collection Page - Copy Collection - fail'),
};
